<template>
  <div class="box">
    <div
      class="top"
      style="
        background: url(../static/images/cs/e2809b0597463b3c879c0f44dded9a81.jpg);
        background-position-x: center;
        background-position-y: center;
        background-repeat: no-repeat;
      "
    ></div>
    <div class="center">
      <div class="text">
        <p class="title">人才招聘</p>
      </div>
      <div>
        <div class="job">
          <div class="job-title">国际物流销售</div>
          <div class="job-spec">岗位职责：</div>

          <ul class="list">
            <li>
              积极开展国际物流销售业务，通过多种渠道拓展市场；
            </li>
            <li>理解客户需求，提供专业的全链路解决方案，包括但不限于专线小包、海外仓、国际快递等；</li>
            <li>维护和增强与客户的业务联系，确保客户满意度；</li>
            <li>参与销售策略的制定和执行，达成销售目标；</li>
            <li>定期与团队成员沟通，共同完成销售任务。</li>
          </ul>

          <div class="job-spec">岗位要求：</div>
          <ul class="list">
            <li>同同岗位经验1年以上，具备良好的沟通能力和谈判技巧；</li>
            <li>对国际物流销售领域有浓厚兴趣，愿意接受挑战；</li>
            <li>能够自主利用资源进行市场开发；</li>
            <li>具有团队合作精神，能够与团队成员有效沟通。</li>
          </ul>
          <div class="job-spec">工作地址：</div>
          <div>广州市白云区集贤路集安街3号凯云商务中心304室。</div>
          <div>郑州管城回族区中国邮政郑州跨境电商产业园486号。</div>
        </div>

        <div class="job">
          <div class="job-title">渠道产品专员</div>
          <div class="job-spec">岗位职责：</div>
          <ul>
            <li>
              日常监控及时效报表输出，及时发现问题并沟通解决，优化产品的时效提升客户体验；
            </li>
            <li>舱位需求及配仓方案审核，出货计划，积压应急方案跟进；</li>
            <li>发现并解决各类尾程派送异常，以及重大异常、赔偿跟进及服务商日常沟通；</li>
            <li>日常出货数据整理，跟进好国内报关以及国外清关进度；</li>
            <li>完成上级主管临时交办的工作任务。</li>
          </ul>
          <div class="job-spec">任职要求：</div>
          <ul>
            <li>
              大专以上学历，物流管理、市场营销等相关专业；
            </li>
            <li>1年以上跨境电商行业或者仓储物流行业相关从业经验经历；</li>
            <li>具有高度的责任心、敬业精神、团队合作精神和积极沟通的态度。</li>
          </ul>
          <div class="job-spec">工作地址：</div>
          <div>广州市白云区集贤路集安街3号凯云商务中心304室。</div>
        </div>

        <!-- <div class="job">
          <div class="job-title">物流操作员</div>
          <div class="job-spec">工作内容：</div>
          <ul>
            <li>物流收发货、分拣货、打包、装卸、仓库日常整理等工作，轻小件为主</li>
            <li>熟悉物流分拣、电脑基本操作、物流扫描者优先</li>
          </ul>
          <div class="job-spec">岗位要求：</div>
          <ul>
            <li>20岁-40岁，有做过物流或者仓库工作者优先</li>
            <li>做事仔细认真、能吃苦耐劳，能适应加班，服从管理</li>
            <li>熟悉物流分拣，物流扫描者优先；（有物流公司或货代公司从业经验者优先）</li>
          </ul>
          <div class="job-spec">工作地址：</div>
          <div>广州市番禺区永善村永峰路23号9栋之二</div>
        </div> -->
      </div>
      <div class="contact">
        <div class="aboutus">
          <p><span>联系人：</span>段先生 / 汤小姐</p>
          <p><span>联系电话：</span>15920931685 / 18719144694</p>
          <p><span>邮箱：</span>duanyixiang@xingyunyi.cn / tangzijun@xingyunyi.cn</p>
          <p><span>地址：</span>广东省白云区集贤路集安街3号凯云商务中心304室</p>
        </div>
        <!-- <img src="@/images/qr.png" class="qrcode" /> -->
      </div>
    </div>
  </div>
</template>
<style scoped>
ul {
  list-style-type: decimal;
}
.contact {
  display: flex;
  justify-content: space-between;
}
.contact .qrcode {
  width: 200px;
}
.job {
  margin: 50px 0;
  padding-bottom: 50px;
  border-bottom: 1px dashed #ccc;
}
.job-title {
  margin: 20px 0;
  font-weight: bold;
  font-size: 18px;
}
.job-spec {
  margin: 10px 0;
  font-weight: bold;
}
.top {
  width: 100%;
  height: 200px;
}

.center {
  width: 1300px;
  box-sizing: border-box;
  padding: 50px 50px 100px 50px;
  min-height: 800px;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: -40px;
  color: #4b4b4b;
}

.text p {
  padding: 30px 0;
  padding-top: 0;
  border-bottom: 1px solid #939393;
  margin: 0;
}
.aboutus p span {
  width: 100px;
  display: inline-block;
  text-align: left;
}
.text .title {
  font-weight: 800;
  font-size: 36px;
}

.aboutus {
  font-size: 18px;
  line-height: 30px;
}
</style>
<script>
export default {
  data () {
    return {
      dto: {}
    }
  },
  name: 'recruit'
}
</script>



// WEBPACK FOOTER //
// src/components/recruit.vue